import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, List, Modal, Space, Tag, Typography, message } from 'antd';
import { useApi } from '../../hooks/use_api';

const { Text } = Typography;

// Install an app from the node's catalog in an entity you administer. Nothing
// is installed by default (todo D3): this is how an entity gets a page. With
// nodeWide (the node settings' Apps tab, superadmins) it installs the app in
// the node itself instead: for everyone signed in here, no host entity.
function InstallAppModal({ open, onClose, hostId, hostName, onInstalled, nodeWide = false }) {
    const api = useApi();
    const navigate = useNavigate();
    const [catalog, setCatalog] = useState([]);
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(null);

    useEffect(() => {
        if (!open) return;
        api.get('/api/apps/catalog').then(setCatalog).catch(() => setCatalog([]));
    }, [api, open]);

    const install = kind => {
        setBusy(kind);
        const body = { kind, name: name.trim() || undefined };
        const request = nodeWide
            ? api.post('/api/apps/node', body)
            : api.post('/api/apps', { ...body, host_id: hostId });
        request
            .then(inst => {
                message.success(`Installed in ${hostName}`);
                onInstalled?.();
                onClose();
                navigate(`/app/${inst.id}`);
            })
            .catch(err => message.error(err.status === 403
                ? (nodeWide ? 'Only a superadmin can install apps in the node' : 'Only an admin of this entity can install apps in it')
                : (err.message || 'Could not install')))
            .finally(() => setBusy(null));
    };

    return (
        <Modal title={`Install an app in ${hostName}`} open={open} onCancel={onClose} footer={null}>
            <Input placeholder="Name (optional)" value={name} onChange={e => setName(e.target.value)} style={{ marginBottom: 12 }} maxLength={255} />
            <List
                dataSource={catalog}
                locale={{ emptyText: 'This node offers no apps yet' }}
                renderItem={m => (
                    <List.Item actions={[<Button key="install" type="link" loading={busy === m.kind} disabled={!!busy && busy !== m.kind} onClick={() => install(m.kind)}>Install</Button>]}>
                        <List.Item.Meta
                            title={<Space size={6}>{m.name}<Tag>{m.kind}</Tag></Space>}
                            description={<>
                                <div>{m.description}</div>
                                <Text type="secondary" style={{ fontSize: 12 }}>It may: {m.scopes.join(', ') || 'nothing beyond itself'}</Text>
                            </>}
                        />
                    </List.Item>
                )}
            />
        </Modal>
    );
}

export default InstallAppModal;
